import { render } from "./MailingAddComponent.vue?vue&type=template&id=6aa75d30&scoped=true"
import script from "./MailingAddComponent.vue?vue&type=script&lang=js"
export * from "./MailingAddComponent.vue?vue&type=script&lang=js"

import "./MailingAddComponent.vue?vue&type=style&index=0&id=6aa75d30&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa75d30"]])

export default __exports__